<h1 class="hero-title hero-title--{{size}} white">
  <span>
    <ng-content select="[before]"></ng-content>{{' '}}
  </span>
  <span class="hero-title__highlight action-color">
    <ng-content select="[highlight]"></ng-content>{{' '}}
  </span>
  <span>
    <ng-content select="[after]"></ng-content>
  </span>
</h1>
